function RepeatIcon() {
  return (
    <svg
      width="47"
      height="28"
      viewBox="0 0 47 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.8232 14.2561C23.3449 14.2561 22.9482 13.8594 22.9482 13.3811V9.50781C22.9482 8.06115 21.7699 6.88281 20.3232 6.88281H4.17651C3.69818 6.88281 3.30151 6.48615 3.30151 6.00781C3.30151 5.52948 3.69818 5.13281 4.17651 5.13281H20.3232C22.7382 5.13281 24.6982 7.09281 24.6982 9.50781V13.3811C24.6982 13.8711 24.3015 14.2561 23.8232 14.2561Z"
        fill="#657892"
      />
      <path
        d="M7.86318 10.5814C7.64152 10.5814 7.41985 10.4997 7.24485 10.3247L3.55818 6.63806C3.39485 6.47472 3.30151 6.25302 3.30151 6.01969C3.30151 5.78636 3.39485 5.56473 3.55818 5.40139L7.24485 1.71469C7.58319 1.37635 8.14318 1.37635 8.48152 1.71469C8.81985 2.05302 8.81985 2.61309 8.48152 2.95142L5.41321 6.01969L8.48152 9.08803C8.81985 9.42636 8.81985 9.98636 8.48152 10.3247C8.30652 10.488 8.08485 10.5814 7.86318 10.5814Z"
        fill="#657892"
      />
      <path
        d="M23.8232 22.8538H7.67651C5.26151 22.8538 3.30151 20.8938 3.30151 18.4788V14.6055C3.30151 14.1271 3.69818 13.7305 4.17651 13.7305C4.65485 13.7305 5.05151 14.1271 5.05151 14.6055V18.4788C5.05151 19.9255 6.22985 21.1038 7.67651 21.1038H23.8232C24.3015 21.1038 24.6982 21.5005 24.6982 21.9788C24.6982 22.4571 24.3015 22.8538 23.8232 22.8538Z"
        fill="#657892"
      />
      <path
        d="M20.1367 26.5423C19.9151 26.5423 19.6934 26.4606 19.5184 26.2856C19.1801 25.9473 19.1801 25.3872 19.5184 25.0489L22.5867 21.9806L19.5184 18.9123C19.1801 18.574 19.1801 18.014 19.5184 17.6756C19.8567 17.3373 20.4167 17.3373 20.7551 17.6756L24.4417 21.3623C24.6051 21.5256 24.6984 21.7473 24.6984 21.9806C24.6984 22.214 24.6051 22.4356 24.4417 22.5989L20.7551 26.2856C20.5917 26.4606 20.3701 26.5423 20.1367 26.5423Z"
        fill="#657892"
      />
      <path
        d="M32.5792 7.824L35.5232 6.8H36.8032V18H35.3312V8.4L32.9472 9.104L32.5792 7.824ZM45.5703 8.112L43.1383 11.392C44.8503 11.712 46.0503 12.912 46.0503 14.688C46.0503 15.776 45.6823 16.64 44.9303 17.264C44.1783 17.888 43.2823 18.208 42.2103 18.208C40.4983 18.208 39.0903 17.408 38.5303 15.936L39.7783 15.2C40.1143 16.24 40.9143 16.752 42.2103 16.752C43.6023 16.752 44.5623 15.984 44.5623 14.688C44.5623 13.392 43.6023 12.608 42.2103 12.608H41.8263L41.2343 11.696L43.8263 8.192H38.8503V6.8H45.5703V8.112Z"
        fill="#657892"
      />
    </svg>
  );
}

export default RepeatIcon;
